import * as $ from 'jquery';
import Control from 'ol/control/Control';
import {updateMapLayers} from '../mapLayers'

export default class RoadType extends Control {
    static get controlName() {
        return 'road-type';
    }

    constructor(opt_options) {
        opt_options = opt_options || {};
        let defaultType = opt_options.roadType || 'fairway';
        let buttonFairway = $('<button class="ol-road-type-fairway selected">航路图</button>');
        let buttonRoad = $('<button class="ol-road-type-road">道路图</button>');
        let buttonBerth = $('<button class="ol-road-type-berth">停泊图</button>');
        let mapType = $(`<div class="ol-road-type ol-unselectable ol-control"></div>`)
            .append(buttonFairway, buttonRoad, buttonBerth);
        super(Object.assign({element: mapType[0]}, opt_options));
        this.set("name", RoadType.controlName);

        let onClick = roadType => {
            this.setRoadType(roadType);
            switch (roadType) {
                case 'fairway':
                    buttonFairway.addClass('selected');
                    buttonRoad.removeClass('selected');
                    buttonBerth.removeClass('selected');
                    break;
                case 'road':
                    buttonFairway.removeClass('selected');
                    buttonRoad.addClass('selected');
                    buttonBerth.removeClass('selected');
                    break;
                case 'berth':
                    buttonFairway.removeClass('selected');
                    buttonRoad.removeClass('selected');
                    buttonBerth.addClass('selected');
                    break;
            }
        };

        buttonFairway.on('click', () => onClick('fairway'));
        buttonRoad.on('click', () => onClick('road'));
        buttonBerth.on('click', () => onClick('berth'));
        setTimeout(() => onClick(defaultType));
    }

    setRoadType(roadType) {
        this.set("roadType", roadType);
        updateMapLayers(this.getMap());
        this.getMap().dispatchEvent({type: "roadTypeChanged", roadType: roadType});
    }
}
